import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import { getProjects } from 'store/actions';
import MediaFile from 'Flow2/util/MediaFile';

const initialState = {
    loading: false,
    comments: {},
    error: ""
};

const setCommentList = (state, action) => {
    const comments = {...state.comments};
    const clipId = action.payload.clipId;
    const projectId = action.payload.projectId;
    
    if(!comments.hasOwnProperty(clipId)) {
        comments[clipId] = {};
    }
    
    comments[clipId][projectId] = action.payload.comments.comment.elements;
        
    return updateObject( state, {
                comments: comments,
                loading: false
            });
}

const deleteCommentList = (state, action) => {
    const comments = {...state.comments};
    const clipId = action.payload.clipId;
    const projectId = action.payload.projectId;
    
    if(comments.hasOwnProperty(clipId) && comments[clipId].hasOwnProperty(projectId)) {
        delete comments[clipId][projectId];
    }
    
     return updateObject( state, {
                comments: comments,
                loading: false
            });
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_COMMENTS_START:
            return updateObject( state, { loading: true });
        case actionTypes.GET_COMMENTS_FAIL:
            return updateObject( state, { loading: false });
        case actionTypes.GET_COMMENTS_SUCCESS:
            if(!Object.keys(action.payload.comments.comment.elements).length) {
                return deleteCommentList(state, action);
            }
            return setCommentList(state, action);
        default:
            return state;
    }
}

export default reducer;
